(function () {
  "use strict";

  const $btnToggleBusca = $(".busca-toggle a");
  const $busca = $(".header-busca");
  const $buscaInput = $busca.find("input");

  $btnToggleBusca.on("click", function (ev) {
    ev.preventDefault();
    ev.stopPropagation();

    if ($busca.hasClass("active")) {
      hideBusca();
    } else {
      showBusca();
    }
  });
  $busca.on("click", function (ev) {
    ev.stopPropagation();
  });

  $("body").on("click", function (ev) {
    hideBusca();
  });

  // Fecha a busca ao pressionar a tecla ESC
  $(document).on("keyup", function (e) {
    if (e.keyCode == 27) {
      hideBusca();
    }
  });

  function showBusca() {
    $busca.addClass("active");
    setTimeout(() => {
      $buscaInput.focus();
    }, 100);
  }

  function hideBusca() {
    $busca.removeClass("active");
    $buscaInput.val("");
  }
})();
